import {windowSizes} from "./sizes";

export class SimplePopup {
    constructor(options = {}) {
        this.$ = $('<div class="simple-popup"></div>')
        this.$.on('click', () => {
            this.hide()
        })
        this.content = options.content
    }

    _position(parent) {
        const sizes = windowSizes()
        const rect = parent.getBoundingClientRect()
        const center = {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2}
        const bordersize = 30 // approx height of the tooltip.

        const yp = center.y
        //
        // let vpos = yp < sizes.height / 2 ? "top" : "bottom";
        let vpos = "bottom"
        // if (sizes.isDesktop) {
        //     vpos = rect.top < bordersize
        //         ? "top"
        //         : "bottom"
        // }
        this.$.css({
            left: center.x,
            top: (vpos === "top" ? rect.top : rect.bottom)
        })
    }

    setContent(newContent) {
        this.content = newContent
    }

    show(parent) {
        if (!!window._active_popup) {
            window._active_popup.hide()
        }
        window._active_popup = this
        this.hide()
        this.$.html(this.content)
        $(document.body).append(this.$)
        this._position(parent)
    }

    hide() {
        this.$.detach()
        window._active_popup = undefined
    }
}
